<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="设备类型ID" prop="deviceTypeId" >
        <a-input v-model="form.deviceTypeId" placeholder="请输入设备类型ID" />
      </a-form-model-item>
      <a-form-model-item label="设备序列号" prop="deviceSn" >
        <a-input v-model="form.deviceSn" placeholder="请输入设备序列号" />
      </a-form-model-item>
      <a-form-model-item label="蓝牙MAC地址" prop="bluetoothMac" >
        <a-input v-model="form.bluetoothMac" placeholder="请输入蓝牙MAC地址" />
      </a-form-model-item>
      <a-form-model-item label="设备名称" prop="deviceName" >
        <a-input v-model="form.deviceName" placeholder="请输入设备名称" />
      </a-form-model-item>
      <a-form-model-item label="屋主宠物ID" prop="ownerPetId" >
        <a-input v-model="form.ownerPetId" placeholder="请输入屋主宠物ID" />
      </a-form-model-item>
      <a-form-model-item label="绑定时间" prop="bindTime" >
        <a-date-picker style="width: 100%" v-model="form.bindTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDevice, addDevice, updateDevice } from '@/api/mibo/device'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        deviceTypeId: null,

        deviceSn: null,

        bluetoothMac: null,

        deviceName: null,

        ownerPetId: null,

        bindStatus: 0,

        onlineStatus: 0,

        bindTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        deviceTypeId: [
          { required: true, message: '设备类型ID不能为空', trigger: 'blur' }
        ],
        deviceSn: [
          { required: true, message: '设备序列号不能为空', trigger: 'blur' }
        ],
        bluetoothMac: [
          { required: true, message: '蓝牙MAC地址不能为空', trigger: 'blur' }
        ],
        deviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ],
        ownerPetId: [
          { required: true, message: '屋主宠物ID不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        deviceTypeId: null,
        deviceSn: null,
        bluetoothMac: null,
        deviceName: null,
        ownerPetId: null,
        bindStatus: 0,
        onlineStatus: 0,
        bindTime: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDevice({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDevice(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDevice(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
